import { FormBase } from 'core/components';

export default class EditFacilityOrderTemplateInactiveReasonForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "inactiveReasonId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.INACTIVE_REASON_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.INACTIVE_REASON_PLACEHOLDER",
                    rules: 'required|integer',           
                },
            ],
        };
    }
}
